const ACCEPTED_EXTENSIONS = ['.png', '.jpeg', '.jpg'];
const MAX_SIZE_MB = 25;

export {ACCEPTED_EXTENSIONS, MAX_SIZE_MB};
